'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgChevrondown } from '@common/icon';
import { cn } from '@core/utils';
import useEmblaCarousel from 'embla-carousel-react';
import { useState } from 'react';
import { Rating } from '@/app/donation/_components/Rating';
import { Image } from '@/components/client';
interface MarketReviewCardProps {
  rating: number;
  reviewer: string;
  date: string;
  content: string;
  imageUrlList?: string[];
  productName?: string;
  answer?: string;
  answerDate?: string;
  onClick?: () => void;
}
const CONTENT_LIMIT = 100;
const ANSWER_LIMIT = 60;
export const MarketReviewCard = t0 => {
  const $ = _c(49);
  const {
    rating,
    reviewer,
    date,
    content,
    imageUrlList: t1,
    productName,
    answer,
    answerDate,
    onClick
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const imageUrlList = t2;
  const [isExpanded, setIsExpanded] = useState(false);
  const [isAnswerExpanded, setIsAnswerExpanded] = useState(false);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      align: "start",
      dragFree: true,
      containScroll: "trimSnaps"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [emblaRef] = useEmblaCarousel(t3);
  const t4 = onClick ? "button" : undefined;
  const t5 = onClick ? 0 : undefined;
  const t6 = onClick && "cursor-pointer";
  let t7;
  if ($[3] !== t6) {
    t7 = cn("flex min-w-0 flex-col gap-12 py-20", t6);
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== onClick) {
    t8 = onClick ? e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick();
      }
    } : undefined;
    $[5] = onClick;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== rating) {
    t9 = <Rating value={rating} size={16} />;
    $[7] = rating;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== reviewer) {
    t10 = <span className="text-Gray-550 typo-caption1">{reviewer}</span>;
    $[9] = reviewer;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="h-10 border-l border-Gray-300" />;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== date) {
    t12 = <span className="text-Gray-550 typo-caption1">{date}</span>;
    $[12] = date;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t10 || $[15] !== t12) {
    t13 = <div className="flex items-center gap-8">{t10}{t11}{t12}</div>;
    $[14] = t10;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t13 || $[18] !== t9) {
    t14 = <div className="flex flex-col gap-8">{t9}{t13}</div>;
    $[17] = t13;
    $[18] = t9;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== productName) {
    t15 = productName && <p className="font-400 text-Gray-600 typo-body4">{productName}</p>;
    $[20] = productName;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== emblaRef || $[23] !== imageUrlList) {
    t16 = imageUrlList.length > 0 && <div className="relative w-full overflow-hidden" ref={emblaRef}><div className="flex gap-8">{imageUrlList.map(_temp)}</div></div>;
    $[22] = emblaRef;
    $[23] = imageUrlList;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== content || $[26] !== isExpanded) {
    t17 = content.length > CONTENT_LIMIT && !isExpanded ? `${content.slice(0, CONTENT_LIMIT)}...` : content;
    $[25] = content;
    $[26] = isExpanded;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== content.length || $[29] !== isExpanded) {
    t18 = content.length > CONTENT_LIMIT && !isExpanded && <span onClick={e_0 => {
      e_0.stopPropagation();
      setIsExpanded(true);
    }} className="inline-block cursor-pointer whitespace-nowrap px-4 font-600 text-Gray-550 typo-body3">더보기</span>;
    $[28] = content.length;
    $[29] = isExpanded;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t17 || $[32] !== t18) {
    t19 = <p className="whitespace-pre-line break-all font-500 text-Gray-800 typo-body3">{t17}{t18}</p>;
    $[31] = t17;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== answer || $[35] !== answerDate || $[36] !== isAnswerExpanded) {
    t20 = answer && <div className="flex flex-col rounded-medium bg-Gray-25 p-20"><div className="flex items-center justify-between pb-4"><p className="font-600 text-Gray-700 typo-body4">판매자</p>{answerDate && <p className="font-400 text-Gray-550 typo-caption1">{answerDate}</p>}</div><p className="whitespace-pre-line break-all font-400 text-Gray-700 typo-body4">{answer.length > ANSWER_LIMIT && !isAnswerExpanded ? `${answer.slice(0, ANSWER_LIMIT)}...` : answer}</p>{answer.length > ANSWER_LIMIT && <button type="button" className="mt-8 flex items-center gap-4 self-start" onClick={e_1 => {
        e_1.stopPropagation();
        setIsAnswerExpanded(_temp2);
      }}><span className="font-600 text-Gray-550 typo-caption1">{isAnswerExpanded ? "\uC811\uAE30" : "\uB354\uBCF4\uAE30"}</span><SvgChevrondown className={cn("size-12 text-Gray-550 transition-transform duration-300", isAnswerExpanded && "-rotate-180")} /></button>}</div>;
    $[34] = answer;
    $[35] = answerDate;
    $[36] = isAnswerExpanded;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== onClick || $[39] !== t14 || $[40] !== t15 || $[41] !== t16 || $[42] !== t19 || $[43] !== t20 || $[44] !== t4 || $[45] !== t5 || $[46] !== t7 || $[47] !== t8) {
    t21 = <div role={t4} tabIndex={t5} className={t7} onClick={onClick} onKeyDown={t8}>{t14}{t15}{t16}{t19}{t20}</div>;
    $[38] = onClick;
    $[39] = t14;
    $[40] = t15;
    $[41] = t16;
    $[42] = t19;
    $[43] = t20;
    $[44] = t4;
    $[45] = t5;
    $[46] = t7;
    $[47] = t8;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  return t21;
};
function _temp(url, index) {
  return <div key={index} className="flex-[0_0_auto]"><Image src={url} alt={`리뷰 이미지 ${index + 1}`} width={128} height={128} className="block aspect-square object-cover" /></div>;
}
function _temp2(prev) {
  return !prev;
}